import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { interval, takeUntil } from 'rxjs';

import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'app-count-down',
    standalone: true,
    imports: [CommonModule, LoaderComponent],
    templateUrl: './count-down.component.html',
    styleUrl: './count-down.component.scss'
})
export class CountDownComponent implements OnInit {
    private static readonly secondsToMsFactor = 1000;
    private static readonly updateIntervalMs = 200;
    private static readonly startingHue = 160;
    private static readonly fullCircle = 360;

    @Input()
    initialTimeInSeconds!: number;

    @Input()
    animate!: boolean;

    @Input()
    colorFill = 'none';

    @Output()
    readonly countDownProgressed = new EventEmitter<number>();

    @Output()
    readonly countDownFinished = new EventEmitter<true>();

    protected remainingTimeInSeconds!: number;
    protected remainingAmount = CountDownComponent.fullCircle;
    protected color = '';
    protected d = '';

    ngOnInit(): void {
        this.remainingTimeInSeconds = this.initialTimeInSeconds;

        if (!this.animate) {
            setTimeout(() => {
                this.updateProgressValues(0);
            });
            return;
        }

        const endTime = Date.now() + CountDownComponent.updateIntervalMs + this.secondsToMs(this.initialTimeInSeconds);

        setTimeout(() => {
            interval(CountDownComponent.updateIntervalMs)
                .pipe(takeUntil(this.countDownFinished))
                .subscribe(() => {
                    this.updateProgressValues(endTime);

                    if (Date.now() >= endTime) {
                        this.countDownFinished.emit(true);
                    }
                });
        });
    }

    private secondsToMs(seconds: number): number {
        return seconds * CountDownComponent.secondsToMsFactor;
    }

    private updateProgressValues(endTime: number): void {
        const remainingRatio = Math.max((endTime - Date.now()) / this.secondsToMs(this.initialTimeInSeconds), 0);

        this.remainingAmount = CountDownComponent.fullCircle * remainingRatio;
        this.remainingTimeInSeconds = Math.ceil(remainingRatio * this.initialTimeInSeconds);

        const hue = CountDownComponent.startingHue * remainingRatio;
        // eslint-disable-next-line spellcheck/spell-checker
        this.color = `hsl(${hue}, 100%, 50%)`;

        this.countDownProgressed.emit(remainingRatio);
    }
}
